"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinType = void 0;
/* eslint-disable no-unused-vars */
var JoinType;
(function (JoinType) {
    JoinType["Left"] = "left";
    JoinType["Inner"] = "inner";
    JoinType["Right"] = "right";
})(JoinType = exports.JoinType || (exports.JoinType = {}));
/* eslint-enable no-unused-vars */ 
